var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waggon-info-nav-button self-centered t-rounded",style:(`
  height: ${_vm.height?_vm.height:''};
  width: ${_vm.width?_vm.width:''};
  ${_vm.nohover?'opacity: 1;':''}
  `)},[_c('v-icon',[_vm._v(" "+_vm._s(`keyboard_arrow_${_vm.direction}`)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }